import { useQuery } from 'react-query'
import { apiGetTools } from '../api/related-content-api'

const TOOLS_KEY = 'tools'

export const useTools = ({ vin, componentId, enabled = true }) => {
  const {
    status,
    data: tools,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useQuery(
    [TOOLS_KEY, vin, componentId],
    async () => {
      const result = await apiGetTools({ vin, componentId })
      return result.data
    },
    {
      refetchOnWindowFocus: false,
      enabled: enabled && !!componentId && !!vin,
    },
  )

  return {
    status,
    tools,
    error,
    isLoading,
    isFetching,
    isError,
    isSuccess,
  }
}
